module.exports = __webpack_public_path__ + "img/1520846483.652573db.jpg";